import { useFormik } from "formik"
import DatePickers from "global/DatePicker/DatePicker"
import {
  useFetchHub,
  useFetchSampleOptions,
} from "global/hooks/useFetchOptions"
import InputNumber from "global/InputNumber/InputNumber"
import InputSelect from "global/InputSelect/InputSelect"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import {
  sharePercentageSchema,
  sharePercentageTableSchema,
} from "global/Validation/Validation"
import { useEffect, useState } from "react"
import { BiPlus } from "react-icons/bi"
import { toast } from "react-toastify"
import { addEditUrls, getUrls } from "services/api.enums"
import { addEditDataAPI, getAPI } from "services/CRUDServices"
import SharePercentTable from "./table"
import { createParams, filterType, firstDayOfMonth } from "../utils"
import InputTreeSelect from "global/InputSelect/inputTreeSelect"
import { useSelector } from "react-redux"
import CustomSwitch from "global/Switch/Switch"

const SharePercentFrom = ({
  open,
  setOpen,
  isView,
  onClose,
  currentData,
  refreshTable,
}) => {
  const [tableData, setTableData] = useState([])
  const { dataOptions } = useFetchSampleOptions("/core-api/sharePercentage/sharePercentageTypes")
  const userInfo = useSelector((state: any) => state.userInfo)

  const [selectedNodes, setSelectedNodes] = useState([
    {
      id: userInfo.currenthub?.id,
      label: userInfo.currenthub?.label,
    },
  ])

  const mainForm = useFormik({
    initialValues: {
      hub: currentData?.hub || {
        id: userInfo.currenthub?.id,
        text: userInfo.currenthub?.label,
      },
      isActive: currentData?.isActive || true,
      validFrom: firstDayOfMonth,
      validTo: "",
      type: currentData?.type,
      defaultPercentage: "",
    },
    validationSchema: sharePercentageSchema,
    onSubmit: async (values) => {
      if (values.type?.id !== 0 && tableData.length === 0) {
        toast.error("حداقل یک مورد باید وارد کنید")
        return
      }

      await addEditDataAPI(
        "/core-api/sharePercentage/v2",
        currentData?.id ? "put" : "post",
        {
          ...values,
          internalSharePercentageDtoList: tableData,
          defaultPercentage: [4, 3].includes(values.type?.id)
            ? undefined
            : values.defaultPercentage,
        }
      )
      toast.success("عملیات با موفقیت انجام شد")
      refreshTable()
      setOpen(false)
    },
  })

  const listItemForm = useFormik({
    initialValues: {
      from: "",
      to: "",
      percentage: "",
    },
    validationSchema: sharePercentageTableSchema,
    onSubmit: (values) => {
      console.log(
        mainForm.values.defaultPercentage,
        listItemForm.values.percentage
      )
      if (
        mainForm.values.type?.id === 2 &&
        +mainForm.values.defaultPercentage > +listItemForm.values.percentage
      ) {
        toast.error("درصد پیش فرض نمی تواند از درصد هدف زنی ریالی بیشتر باشد ")
        return
      }

      setTableData([...tableData, values])
      listItemForm.resetForm()
    },
  })

  const removeFromList = (index) => {
    const newList = [...tableData]
    newList.splice(index, 1)
    setTableData(newList)
  }

  useEffect(() => {
    if (!currentData?.id) return
    getAPI(
      `/core-api/sharePercentage/v2/get?${createParams(currentData)}`
    ).then((res) => {
      mainForm.setValues({
        hub: res.data.hub,
        validFrom: res.data.validFrom,
        validTo: res.data.validTo,
        type: res.data.type,
        defaultPercentage: res.data.defaultPercentage,
        isActive: true,
      })

      if (res.data.internalSharePercentageDtoList) {
        setTableData(res.data.internalSharePercentageDtoList)
      }
    })
  }, [currentData])

  const {
    dataOptions: { options: hubData },
  } = useFetchSampleOptions("/core-api/hub/allAbleToRegisterOrder")

  return (
    <Modal
      visible={open}
      setVisible={setOpen}
      title="حق السهم"
      handleClose={onClose}
    >
      {isView ? (
        <SharePercentTable
          tableData={tableData}
          onDelete={removeFromList}
          type={mainForm.values.type?.id}
        />
      ) : (
        <form onSubmit={mainForm.handleSubmit}>
          <div className="grid3">
            <InputTreeSelect
              customTree={[hubData]}
              selectedNodes={selectedNodes}
              setSelectedNodes={setSelectedNodes}
              type="select"
              singleSelect
              important
              wrapperClassName="filterInput"
              initialValue={mainForm.values.hub?.text}
              onSelect={(value) => {
                setSelectedNodes(value)
                mainForm.setFieldValue("hub", {
                  id: value[0]?.id,
                  text: value[0]?.label,
                })
              }}
              // error={mainForm.touched.hub && mainForm.errors.hub?.text}
            />
            <DatePickers
              title="تاریخ اعتبار از"
              name="validFrom"
              WrapperClassName="w-full"
              handleChange={mainForm.setFieldValue}
              values={mainForm.values.validFrom}
              important
              error={
                mainForm.touched.validFrom && mainForm.errors.validFrom?.day
              }
              readOnly
            />

            <DatePickers
              title="تاریخ اعتبار تا"
              name="validTo"
              WrapperClassName="w-full"
              handleChange={mainForm.setFieldValue}
              values={mainForm.values.validTo}
              important
              error={mainForm.touched.validTo && mainForm.errors.validTo?.day}
              minDate={mainForm.values.validFrom}
              readOnly={!mainForm.values.validFrom}
            />
          </div>

          <div className="my-6 border rounded-xl gap-6 pt-6 px-6">
            <div className="grid3">
              <InputSelect
                label="روش محاسبه حق السهم"
                important
                name="type"
                handleChange={(name, value) => {
                  mainForm.setFieldValue(name, value)
                  setTableData([])
                }}
                values={mainForm.values.type}
                error={mainForm.touched.type && mainForm.errors.type}
                options={filterType(dataOptions.options)}
                isDisabled={currentData?.id}
              />

              {![4, 3].includes(mainForm.values.type?.id) && (
                <InputNumber
                  label="درصد پیش فرض"
                  important
                  name="defaultPercentage"
                  handleChange={mainForm.setFieldValue}
                  values={mainForm.values.defaultPercentage}
                  error={
                    mainForm.touched.defaultPercentage &&
                    mainForm.errors.defaultPercentage
                  }
                />
              )}

              {!!currentData ? (
                <CustomSwitch
                  active={mainForm.values.isActive}
                  handleChange={(value: any) =>
                    mainForm.setFieldValue("isActive", value)
                  }
                />
              ) : null}
            </div>
            {![0].includes(mainForm.values.type?.id) &&
              mainForm.values.type?.id && (
                <>
                  <form onSubmit={listItemForm.handleSubmit}>
                    <div className="grid3 mt-6">
                      {![2, 1].includes(mainForm.values.type?.id) && (
                        <InputNumber
                          label={
                            [4, 2].includes(mainForm.values.type?.id)
                              ? [2].includes(mainForm.values.type?.id)
                                ? "مبلغ"
                                : "از (ریال)"
                              : "از(تعداد)"
                          }
                          name="from"
                          handleChange={listItemForm.setFieldValue}
                          // onBlur={listItemForm.handleBlur}
                          values={listItemForm.values.from}
                          error={
                            listItemForm.touched.from &&
                            listItemForm.errors.from
                          }
                        />
                      )}

                      <InputNumber
                        label={
                          [4, 2].includes(mainForm.values.type?.id)
                            ? [2].includes(mainForm.values.type?.id)
                              ? "مبلغ"
                              : "تا (ریال)"
                            : [1].includes(mainForm.values.type?.id)
                            ? "تعداد"
                            : "تا(تعداد)"
                        }
                        name="to"
                        handleChange={listItemForm.setFieldValue}
                        // onBlur={listItemForm.handleBlur}
                        values={listItemForm.values.to}
                        error={
                          listItemForm.touched.to && listItemForm.errors.to
                        }
                      />

                      <div className="w-full">
                        <InputNumber
                          label="درصد"
                          name="percentage"
                          handleChange={listItemForm.setFieldValue}
                          // onBlur={listItemForm.handleBlur}
                          values={listItemForm.values.percentage}
                          error={
                            listItemForm.touched.percentage &&
                            listItemForm.errors.percentage
                          }
                        />
                      </div>
                    </div>

                    <div className="w-full flex justify-end my-6">
                      <SimpleButton
                        icon={<BiPlus color="white" />}
                        text="درج در لیست"
                        className="full-tomato-btn px-[50px] w-fit"
                        handelClick={listItemForm.handleSubmit}
                        type="button"
                        disabled={
                          [2, 1].includes(mainForm.values.type?.id) &&
                          tableData.length > 0
                        }
                      />
                    </div>
                  </form>

                  <SharePercentTable
                    tableData={tableData}
                    onDelete={removeFromList}
                    type={mainForm.values.type?.id}
                  />
                </>
              )}
          </div>

          <div className="btnForm">
            <SimpleButton
              handelClick={() => setOpen(false)}
              text="لغو"
              className="text-tomato"
              type="button"
            />
            <SimpleButton
              type="submit"
              text="ذخیره"
              className="full-tomato-btn"
              loading={mainForm.isSubmitting}
            />
          </div>
        </form>
      )}
    </Modal>
  )
}

export default SharePercentFrom
